<template>
  <div>
    <MenuMovilTP />
    <main class="container mb-4 d-lg-block d-block dkt">
      <Titulo titulo="BUSCADOR DE CARRERAS" subTitulo="TÉCNICO PROFESIONALES" />
      <FormBusqueda @buscarCarrera="buscarCarreras" />
    </main>
    <main class="container mb-4">
      <TagsBusqueda
        :tagSeleccionado="tipoVista"
        :cantidadResultados="cantidadCarreras"
        @cambiarVista="cambiarVista"
        @cambiarOrden="cambiarOrden"
        @buscarCarrera="buscarCarreras"
      />
      <b-alert dismissible v-model="showAlert" show
        >No se encontraron resultados para la búsqueda realizada...</b-alert
      >
      <VistaTarjetas
        v-show="tipoVista === 'detalle'"
        :listadoContenido="listadoCarreras"
        tipoFicha="CARRERA"
      />
      <VistaTabla
        v-show="tipoVista === 'lista'"
        :listadoCarreras="listadoCarreras"
      />
    </main>
    <Iconografia />
    <MenuMovilUni />
  </div>
</template>

<script>
import ApiRegiones from "@/services/ApiRegiones";
import ApiTecnicoProf from "@/services/ApiTecnicoProf";
import Titulo from "@/components/generales/paginas/TituloPagina";
import FormBusqueda from "@/components/buscadorTP/FormBusqueda";
import Iconografia from "@/components/generales/Iconografia";
import TagsBusqueda from "@/components/buscadorTP/TagsBusqueda";
import { mapGetters, mapActions } from "vuex";
import VistaTarjetas from "@/components/generales/paginas/VistaTarjetas";
import VistaTabla from "@/components/buscadorTP/VistaTabla";
import { MensajesDeCarga } from "@/utils/BusesDeEventos.js";
import MenuMovilTP from "@/components/generales/menuMovil/TecnicoProfesional";
import MenuMovilUni from "@/components/generales/menuMovil/AdmisionUniversitaria";
import ordenamientoMixin from "@/mixins/OrdenamientoCarreras.js";
export default {
  name: "BuscadorTP",
  components: {
    Titulo,
    FormBusqueda,
    TagsBusqueda,
    Iconografia,
    VistaTarjetas,
    VistaTabla,
    MenuMovilTP,
    MenuMovilUni
  },
  mixins: [ordenamientoMixin],
  data() {
    return {
      tipoVista: "",
      listadoCarreras: [],
      showAlert: false
    };
  },
  mounted() {
    this.tipoVista = this.vista;
    this.reiniciarBusqueda();
  },
  computed: {
    ...mapGetters(["getBusquedasAplicadas"]),
    cantidadCarreras() {
      return this.listadoCarreras.length;
    },
    vista() {
      return this.$store.state.vista;
    }
  },
  methods: {
    ...mapActions([
      "setVista",
      "setCarreras",
      "clearSeleccionados",
      "setCriterioOrden"
    ]),

    async buscarCarreras(busqueda) {
      MensajesDeCarga.$emit("cargar");
      if (
        busqueda.region !== null ||
        busqueda.carrera !== "" ||
        busqueda.sectorProductivo !== null ||
        busqueda.nombreCarreraGenerico !== null ||
        busqueda.nombreInstitucion !== null ||
        busqueda.jornada !== null
      ) {
        let carreras = await ApiTecnicoProf.getCarreras(busqueda);
        if (carreras || carreras !== "") {
          this.ordenarCarreras(carreras);
          this.showAlert = false;
        } else {
          this.setCarreras([]);
          this.listadoCarreras = [];
          this.showAlert = true;
        }
      } else {
        this.setCarreras([]);
        this.listadoCarreras = [];
        this.clearSeleccionados;
      }
      MensajesDeCarga.$emit("cargado");
    },
    reiniciarBusqueda() {
      let busquedasAplicadas = this.getBusquedasAplicadas;
      let nuevaBusqueda = {
        region: null,
        carrera: "",
        sectorProductivo: null,
        nombreCarreraGenerico: null,
        nombreInstitucion: null,
        jornada: null
      };
      if (busquedasAplicadas.length >= 1) {
        busquedasAplicadas.forEach(f => {
          switch (f.tipo) {
            case "REGION":
              nuevaBusqueda.region = f.filtro;
              break;
            case "SECTOR":
              nuevaBusqueda.sectorProductivo = f.filtro;
              break;
            case "C_GENERICA":
              nuevaBusqueda.nombreCarreraGenerico = f.filtro;
              break;
            case "INSTITUCION":
              nuevaBusqueda.nombreInstitucion = f.filtro;
              break;
            case "JORNADA":
              nuevaBusqueda.jornada = f.filtro;
              break;
            case "CARRERA":
              nuevaBusqueda.carrera = f.filtro;
              break;
            default:
              break;
          }
        });
        this.buscarCarreras(nuevaBusqueda);
      }
    },
    ordenarCarreras(lstadoCarreras) {
      let carreras = [];
      if (lstadoCarreras) {
        lstadoCarreras.forEach(i => {
          const instituto = {
            codigo: i.codigo,
            nombre: i.nombre,
            nombreCorto: i.nombreCorto,
            gratuidad: i.gratuidad,
            acreditado: i.acreditado,
            acreditacion: i.acreditacion,
            urlLogo: i.urlLogo,
            pantone: i.pantone,
            observacionAcreditacionCNA: i.observacionAcreditacionCNA
          };
          i.sedes.forEach(s => {
            let region = ApiRegiones.getRegionesYComunas().find(
              r => r.valorBusqueda === s.region
            );
            const sede = {
              codigo: s.codigo,
              nombre: s.nombre,
              region: region.nombreRegion
            };

            carreras.push(
              ...s.carreras.map(function(carr) {
                let carreraSimple = {};
                carreraSimple = {
                  datos: carr,
                  sede: sede,
                  institucion: instituto
                };
                return carreraSimple;
              })
            );
          });
        });
      }
      carreras = this.ordenamientoFinal(carreras);
      this.setCarreras(carreras);
      this.listadoCarreras = carreras;
    },
    ordenamientoFinal(listado) {
      let ordenado;
      let carrerasPresenciales = [];
      let carrerasNoPresenciales = [];
      listado.forEach(c => {
        const val = this.ordenModalidad.indexOf(c.datos.jornada);
        if (val < 2) {
          carrerasPresenciales.push(c);
        } else {
          carrerasNoPresenciales.push(c);
        }
      });

      let ordenadoPres = this.ordenarPorCondiciones(carrerasPresenciales);
      let ordenadoNoPres = this.ordenarPorCondicionesNoPresenciales(
        carrerasNoPresenciales
      );
      ordenado = ordenadoPres.concat(ordenadoNoPres);
      return ordenado;
    },
    cambiarVista(valor) {
      this.tipoVista = valor;
      this.setVista(valor);
    },
    cambiarOrden(orden) {
      this.setCriterioOrden(orden);
      let listado = this.listadoCarreras;
      switch (orden) {
        case "NOMBRE_CARRERA_ASCENDENTE":
        case "NOMBRE_CARRERA_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = a.datos.nombre;
            let n2 = b.datos.nombre;
            if (orden === "NOMBRE_CARRERA_ASCENDENTE") {
              return n1.localeCompare(n2);
            } else {
              return n2.localeCompare(n1);
            }
          });
          break;
        case "NOMBRE_INSTITUTO_ASCENDENTE":
        case "NOMBRE_INSTITUTO_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = a.institucion.nombre;
            let n2 = b.institucion.nombre;
            if (orden === "NOMBRE_INSTITUTO_ASCENDENTE") {
              return n1.localeCompare(n2);
            } else {
              return n2.localeCompare(n1);
            }
          });
          break;
        case "ARANCEL_ASCENDENTE":
        case "ARANCEL_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = a.datos.arancelAnual;
            let n2 = b.datos.arancelAnual;
            if (orden === "ARANCEL_ASCENDENTE") {
              return n1 - n2;
            } else {
              return n2 - n1;
            }
          });
          break;
        case "DURACION_ASCENDENTE":
        case "DURACION_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = this.obtenerValorRealDuracion(
              a.datos.duracionFormalPrograma,
              a.datos.regimen
            );
            let n2 = this.obtenerValorRealDuracion(
              b.datos.duracionFormalPrograma,
              b.datos.regimen
            );
            if (orden === "DURACION_ASCENDENTE") {
              return n1 - n2;
            } else {
              return n2 - n1;
            }
          });
          break;
        default:
          break;
      }
      this.listadoCarreras = listado;
    },
    obtenerValorRealDuracion(duracion, regimen) {
      let valor = 0;
      switch (regimen) {
        case "BIMESTRES":
          valor = duracion * 2;
          break;
        case "TRIMESTRES":
          valor = duracion * 3;
          break;
        case "SEMESTRES":
          valor = duracion * 6;
          break;
        case "AÑOS":
          valor = duracion * 12;
          break;
        default:
          valor = duracion;
          break;
      }
      return valor;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/BuscadoresTP/BuscadorTP.vue